import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getOrganizations } from '../actions/organizationActions';
import { getTodaysWeather } from '../actions/weatherActions';
import WeatherWidget from './../components/WeatherWidget';

const mapDispatchToProps = dispatch => {
  return {
    getOrganizations: () => {
      dispatch(getOrganizations());
    },
    getTodaysWeather: (latitude,longitude,timezone) => {
      dispatch(getTodaysWeather(latitude,longitude,timezone));
    }
  };
};

const mapStateToProps = state => ({
  organizationsList: state.organizations.organizationsList,
  organizations: state.organizations.organizations,
  fetchingOrganizationsStatus: state.organizations.fetchingOrganizationsStatus,
  todaysWeather: state.weather.todaysWeather,
  fetchingWeatherStatus: state.weather.fetchingWeatherStatus
});

const WeatherContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(WeatherWidget));
export default WeatherContainer;



// WEBPACK FOOTER //
// ./src/containers/WeatherContainer.js